import { useState, useRef } from "react"

export default function App() {
  const [text, setText] = useState("")
  const [generated, setGenerated] = useState(null)
  const canvasRef = useRef(null)

  const generate = () => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext("2d")

    // iPhone壁紙用に縦長サイズ（1080x1920）
    const W = 1170
    const H = 2532

    // iphoneごとによってサイズを変えられる
    // iphone12 mini 1080x2340
    // iphone12/12 pro 1170*2532 

    canvas.width = W
    canvas.height = H

    // 背景色
    ctx.fillStyle = "#111" // 黒背景
    ctx.fillRect(0, 0, W, H)

    // テキスト描画
    ctx.fillStyle = "white"
    ctx.font = "bold 80px sans-serif"
    ctx.textAlign = "center"
    ctx.textBaseline = "middle"

    const lines = text.split("\n")
    const lineHeight = 120
    const startY = H / 2 - ((lines.length - 1) * lineHeight) / 2

    lines.forEach((line, i) => {
      ctx.fillText(line, W / 2, startY + i * lineHeight)
    })

    const url = canvas.toDataURL("image/png")
    setGenerated(url)
  }

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <h2>格言スマホ壁紙メーカー / Proverb Smartphone Wallpaper Maker</h2>

      <textarea
        rows={4}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="ここに文字を入力してください / Type your text here"
        style={{ width: "100%", padding: 10, fontSize: 18 }}
      />

      <button
        onClick={generate}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          fontSize: 18
        }}
      >
        作成 / Create
      </button>

      <canvas ref={canvasRef} style={{ display: "none" }} />

      {generated && (
        <div style={{ marginTop: 40, textAlign: "center" }}>
          <h3>作成された壁紙 / Created wallpaper</h3>
          <img
            src={generated}
            style={{ width: "300px", borderRadius: 10 }}
            alt="wallpaper"
          />
          <p>スマホで長押し保存できます / You can long press and save on your smartphone</p>
        </div>
      )}

      <div style={{ marginTop: 60, textAlign: "center", opacity: 0.8 }}>
        <p>
          もし気に入っていただけましたら、コーヒー1杯支援していただけたら幸いです 🙌/ If you like it, please support me with a cup of coffee 🙌
        </p>
        <a
          href="https://www.buymeacoffee.com/sakuasami"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
            alt="Buy Me A Coffee"
            style={{ height: "60px", width: "217px" }}
          />
        </a>
      </div>
    </div>
  )
}
